import React, {
  useState,
  createContext,
  useSyncExternalStore,
} from 'react';
import PropTypes from 'prop-types';

import consent from '../../modules/consent';
import googleMapsApiLoader from '../../modules/google-maps-api-loader';

function subscribeToApiLoader(callback) {
  googleMapsApiLoader.subscribe(callback);
  return () => {
    googleMapsApiLoader.unsubscribe(callback);
  };
}

function getApiLoaderSnapshot() {
  return googleMapsApiLoader.getState() === 'ready';
}

function subscribeToConsent(callback) {
  consent.addEventListener('change', callback);
  return () => {
    consent.removeEventListener('change', callback);
  };
}

function getConsentSnapshot() {
  return consent.getConsent().dealers;
}

export const MapContext = createContext();

export function MapContextProvider(props) {
  const [map, setMap] = useState(null);
  const [mapEnabled, setMapEnabled] = useState(false); // Whether map was activated by user
  const [mapVisible, setMapVisible] = useState(false); // Whether map is visible (always true in desktop, true if dialog is open in mobile)
  const googleMapsReady = useSyncExternalStore(subscribeToApiLoader, getApiLoaderSnapshot);
  const googleMapsConsent = useSyncExternalStore(subscribeToConsent, getConsentSnapshot);

  if (mapEnabled && googleMapsConsent && googleMapsApiLoader.getState() === 'initial') {
    googleMapsApiLoader.load();
  }

  return (
    <MapContext.Provider
      value={{
        googleMapsReady,
        googleMapsConsent,
        map,
        mapEnabled,
        setMap,
        setMapEnabled,
        mapVisible,
        setMapVisible,
      }}
    >
      {props.children}
    </MapContext.Provider>
  );
}

MapContextProvider.propTypes = {
  children: PropTypes.node,
};
